import React, { Component } from 'react'
import styles from './style.module.less'
import { Modal, Input, Button } from 'hljd'
import { observer } from 'mobx-react'
import store from '../store'

@observer
export default class extends Component {
  render() {
    const {
      writeVisible,
      contact_phone,
      contact_email,
      code,
      imgCode,
      imgCodeSrc,
      is_getCode,
      count,
      contact_phone_show,
      contact_email_show,
      code_show,
      imgCode_show
    } = store
    return (
      <Modal closable={false} footer={null} width={690} visible={writeVisible}>
        <div className={styles.modalbox}>
          <p className={styles.title}>注册申请</p>
          <div className={styles.inner}>
            <p className={styles.p1}>
              <img src="http://qnm.hunliji.com/o_1bou1u1j11htddt31v4pqoc4k7.png" />
              <span style={{ paddingLeft: 10 }}>支付成功</span>
            </p>
            <p className={styles.p2}>
              填写联系方式和材料接收邮箱，及时沟通注册消息
            </p>
            <div className={styles.form}>
              <div className={styles.item}>
                <span className={styles.tip}>手机号码</span>
                <Input
                  style={{
                    width: 350,
                    borderColor: contact_phone_show ? 'red' : ''
                  }}
                  placeholder="请输入"
                  value={contact_phone}
                  onChange={store.changeValue('contact_phone')}
                />
                {contact_phone_show && (
                  <p className={styles.error}>请输入正确的手机号码</p>
                )}
              </div>
              <div className={styles.item}>
                <span className={styles.tip}>验证码</span>
                <Input
                  style={{ width: 212, borderColor: imgCode_show ? 'red' : '' }}
                  placeholder="请输入"
                  value={imgCode}
                  onChange={store.changeValue('imgCode')}
                />
                <img
                  className={styles.imgCode}
                  src={imgCodeSrc}
                  onClick={store.imgCodeSrcChange}
                />
                {imgCode_show && (
                  <p className={styles.error}>请输入正确的图形验证码</p>
                )}
              </div>
              <div className={styles.item}>
                <span className={styles.tip}>短信验证码</span>
                <Input
                  style={{ width: 252, borderColor: code_show ? 'red' : '' }}
                  placeholder="请输入"
                  value={code}
                  onChange={store.changeValue('code')}
                />
                <Button
                  ghost
                  type="primary"
                  onClick={store.getMsgCode}
                  style={{ marginLeft: 10, width: 86, height: 44 }}
                  disabled={is_getCode}
                >
                  {!is_getCode ? '获取' : count + 's'}
                </Button>
                {code_show && (
                  <p className={styles.error}>请输入正确的短信验证码</p>
                )}
              </div>
              <div className={styles.item} style={{ margin: 0 }}>
                <span className={styles.tip}>材料接收邮箱</span>
                <Input
                  value={contact_email}
                  style={{
                    width: 350,
                    borderColor: contact_email_show ? 'red' : ''
                  }}
                  placeholder="请输入"
                  onChange={store.changeValue('contact_email')}
                />
                {contact_email_show && (
                  <p className={styles.error}>请输入正确的邮箱</p>
                )}
              </div>
            </div>
          </div>
          <div className={styles.btnClick}>
            <span className={styles.yes} onClick={store.toSubmit}>
              提交
            </span>
            <span className={styles.close} onClick={store.closeModal}>
              关闭
            </span>
          </div>
        </div>
      </Modal>
    )
  }
}
